document.addEventListener("readystatechange", (event) => {
    if (event.target.readyState === "complete") {
		(function($) {

			if ( document.querySelector('.page-template-tempate-landing-page-august-2017') ) {
				return;
			}

			const getCookie = (name) => {

				const value = '; ' + document.cookie;
				const parts = value.split('; ' + name + '=');

				if ( parts.length == 2 ) {
					return parts.pop().split(';').shift();
				}
			}
			const fetchLocation = (ajaxurl, ajaxData) => {
				$.ajax({
					type   : 'GET',
					url    : ajaxurl,
					headers: {
						'Cache-control': 'max-age=86400, public',
						'Pragma'       : 'cache'
					},
					cache  : true,
					data   : ajaxData,
					success: function(res) {

						const result = JSON.parse(res);

						if ( result.code == 200 ) {
							if( ajaxData.hasOwnProperty('market_id') ){
								localStorage.setItem('cc-market-url' + ajaxData.market_id, result.url);
								localStorage.setItem('cc-market-target' + ajaxData.market_id, result.target);
								localStorage.setItem('cc-market-name' + ajaxData.market_id, result.name);
							}

							$('.location-found').each(function() {

								$(this)
									.siblings()
									.addClass('inactive')
									.hide();

								$(this)
									.removeClass('hide')
									.find('.market-name')
									.attr('href', result.url)
									.attr('target', result.target)
									.html(result.name);
							});
						}
					}
				});
			}
			/* check if a location is set */
			const checkIfLocationFound = () => {

				const ajaxData = {
					action: 'calclosets_location_found'
				}

				const getUrlParameter = (sParam) => {

					const sPageURL = decodeURIComponent(window.location.search.substring(1)),
						sURLVariables = sPageURL.split('&');

					let	i;

					for ( i = 0; i < sURLVariables.length; i++ ) {

						const sParameterName = sURLVariables[i].split('=');

						if ( sParameterName[0] === sParam ) {
							return sParameterName[1] === undefined ? true : sParameterName[1];
						}
					}
				};

				if ( getUrlParameter('CC1') ) {
					ajaxData.franchise_id = getUrlParameter('CC1');

				}
				else if ( getCookie('STYXKEY_lf_market') ) {
					ajaxData.market_id = getCookie('STYXKEY_lf_market');

				}
				//Check for local storage for this market
				if (ajaxData.hasOwnProperty('market_id') ){
					const market_url = localStorage.getItem('cc-market-url' + ajaxData.market_id);
					const market_target = localStorage.getItem('cc-market-target' + ajaxData.market_id);
					const market_name = localStorage.getItem('cc-market-name' + ajaxData.market_id);
					if( market_url && market_target && market_name){
						$('.location-found').each(function() {

							$(this)
								.siblings()
								.addClass('inactive')
								.hide();
	
							$(this)
								.removeClass('hide')
								.find('.market-name')
								.attr('href', market_url)
								.attr('target', market_target)
								.html(market_name);
						});
					}else {
						fetchLocation(ajaxurl, ajaxData);
					}

				}else{
					fetchLocation(ajaxurl, ajaxData);
				}
			}

			$('.lf-finder').on('click', function(e) {

				e.preventDefault();
				e.stopPropagation();

				const $lfFinder = $(this);

				$lfFinder.attr('disabled', true);

				setTimeout(function() {

					const $button = $lfFinder.parent().parent();
					let search = $button.find('[name="lf"]').val();

					if ( search === '' || search === 'false' ) {
						search = $button.find('.autocomplete').val();
						$button.find('[name="lf"]').val(search);
					}

					const matches = search.match(/\d+/g);

					if ( matches == null ) {

						if ( search.indexOf(',') < 0 ) {

							$('.not-valid-modal').modal();
							$lfFinder.attr('disabled', false);

							return false;
						}
					}

					let form;

					if ( $button.hasClass('design-consultant-form') ) {
						form = 'our-designers';
					}
					else {
						form = 'default';
					}

					// prevent from pinging the server if the honeypot field is not empty
					if ( $button.find('.hidden-field').val() !== '' ||
					$button.find('[name="lf"]').val() == '' ) {
						return false;
					}

					$.ajax({
						url       : ajaxurl,
						async     : false,
						data      : {
							action   : 'location-finder',
							search   : $button.find('[name="lf"]').val(),
							area	 : $button.find('.selected').data('attr'),
							form	 : form,
							honeypot : $button.find('.hidden-field').val(),
							// send the nonce along with the request
							nonce    : $button.find('.nonce').val(),
							wpml_lang: wpml_lang
						},
						method    : 'POST',
						dataType  : 'json',
						beforeSend: function() {
							$lfFinder.attr('disabled', true);
						},
						success   : function(response) {

							$('.mobile-header .mobile-locate-me a').removeClass('active');

							if (response.errors == '') {

								let location_window_reference = window.open(response.url, response.target);

								if (response.target !== '_self') {
									if (location_window_reference == null) {
										//console.log('window.open failed. showing modal');

										$('.location-found-modal')
											.find('.location-found-link')
											.attr('href', response.url)
											.attr('target', response.target)
											.on('click', function(e) {
												// Page reload required to properly show location in case user returns to primary website
												window.setTimeout(function(){
													//console.log('reloading page - modal link clicked');
													window.location.reload();
												},1000);
											})
											.end()
											.modal()
										;
									} else {
										// Page reload required to properly show location in case user returns to primary website
										if ( response.target === '_blank' ) {
											window.setTimeout(function(){
												//console.log('reloading page - external tab opened');
												window.location.reload();
											},1000);
										}
									}
								}
								$lfFinder.attr('disabled', false);
							}
							else {
								$lfFinder.attr('disabled', false);
								$('.not-found-modal').modal();
							}
						},
						error: function (xhr, ajaxOptions, thrownError) {
							console.log(xhr.status);
							console.log(thrownError);
							$lfFinder.attr('disabled', false);
						}
					});

				}, 500);

				return false;
			});

			$('body').on('click', '.lf-change', function(e) {

				e.stopPropagation();

				let $locationFound;

				if ( $(this).parent().hasClass('market__links') ) {
					$locationFound = $(this).parents('.location-found');
				}
				else if ( $(this).parent().parent().hasClass('showroom-cookie') ) {
					$locationFound = $(this).parent().parent();
				}
				else {
					$locationFound = $(this).parent();
				}

				$locationFound.hide();

				$(this).parent('div').find('.inactive').show();

				if ( $locationFound.hasClass('showroom-cookie') ) {
					$locationFound.next().css('display', 'table-cell');
				}
				else {
					$locationFound.next().show();
				}

				$(document.body).on('click.location-finder', function() {

					const $body = $(this);

					$locationFound.show();

					$('.lf-form.inactive').hide();
					$('.inactive.mobile-form').hide();

					$body.off('click.location-finder');
				});
			});

			$('.lf-form').on('click', (e) => {
				e.stopPropagation();
			});

			checkIfLocationFound();

		})(jQuery);
	}
});
